import React, { useContext } from 'react'
import Spinner  from "./Spinner";
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';
import { getSerialNumberData } from "../utilities";

function NextButton({ requiredInputRefs=[], beforeDismount = null, handler=null, text="Next", isLoading }) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);
    const inputErrorClasses = ["outline", "outline-2", "outline-[#FD6F64]"]
    const labelErrorClasses = ["after:content-[attr(data-error-msg)]", "before:content-[attr(data-error-icon)]"]

    const handleNext = handler || async function(){
        const errors = []
        requiredInputRefs.forEach(async ref => {
            ref.current.classList.remove(...inputErrorClasses)
            ref.current.parentElement.classList.remove(...labelErrorClasses)
            ref.current.parentElement.classList.add("before:content-none")

            const label = ref.current.closest('label')

            if (!ref.current.value) {
                errors.push(ref)
            } else if (ref.current.name === 'email' && !validateEmail(ref.current.value)) {
                const errorMsg = "Please provide a valid email address"
                label.setAttribute('data-error-msg', errorMsg)
                errors.push(ref)
            } else if (ref.current.name === 'phoneNumber' && !validatePhone(ref.current.value)) {
                const errorMsg = "Please provide a valid phone number"
                label.setAttribute('data-error-msg', errorMsg)
                errors.push(ref)
            }
        })

        let serialNumberInputRef = null;
        let modelNumberInputRef = null;

        // Get the input refs for serialNumber and modelNumber
        requiredInputRefs.forEach(ref => {
            if (!ref.current.value) {
                errors.push(ref)
            } else if (ref.current.name === 'serialNumber') {
                serialNumberInputRef = ref;
            } else if (ref.current.name === 'modelNumber') {
                modelNumberInputRef = ref;
            }
        })

        if (serialNumberInputRef && modelNumberInputRef) {
            try {
                // Send a fetch request to the app with the serial number to get back the sku
                const { sku } = await getSerialNumberData(state.serialNumber)
    
                if (sku !== state.modelNumber) {
                    const errorMsg = "Serial number does not match model number"
                    const label = modelNumberInputRef.current.closest('label')
                    label.setAttribute('data-error-msg', errorMsg)
                    highlightError(modelNumberInputRef.current)
                    return;
                }
            } catch(error) {
                if (serialNumberInputRef && modelNumberInputRef) {
                    const errorMsg = "Please Enter Valid Serial Number"
                    const label = serialNumberInputRef.current.closest('label')
                    label.setAttribute('data-error-msg', errorMsg)
                    highlightError(serialNumberInputRef.current)
                    return;
                }
            }
        }

        if (errors.length > 0) {
            errors.forEach(error => highlightError(error.current))
            return;
        }

        if (beforeDismount) {
            await beforeDismount()
        }
        dispatch({ type: 'setActiveStep', payload: state.activeStep + 1 })

    }

    function highlightError(errorElement) {
        errorElement.classList.add(...inputErrorClasses)
        errorElement.parentElement.classList.add(...labelErrorClasses)
        errorElement.parentElement.classList.remove("before:content-none")
    }
    
    function validateEmail(email) {
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailRegex.test(email);
    }

    function validatePhone(phone) {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    }

    return (
        <button
            className="px-[52px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl mx-auto my-8"
            onClick={handleNext}
        >
            {isLoading ? <Spinner /> : `${text}`}
        </button>
    )
}
  
export default NextButton